import { TargetsLensData } from '@upright/ui/common/upright/core/impact-lenses/targets/types';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { CarouselContext, useCarouselContext } from '../../../impact-lens-profile/context';

export function useTargetsLensContext() {
  const context = useCarouselContext();
  if (context.lensType === ImpactLensType.TARGETS) {
    const targetsContext = context as CarouselContext<ImpactLensType.TARGETS>;
    return {
      data: targetsContext.data as TargetsLensData,
      selection: targetsContext.selectionState,
      setSelection: targetsContext.setSelectionState,
    };
  }
  return undefined;
}
